import { useTranslation } from "react-i18next";
import { useCorrelativeStore } from "../store/useCorrelativeStore";
import * as Yup from "yup";
import { validateYupStringWithSpecialCharacters } from "helpers/functionsHelpers";
import { useFormik } from "formik";
import { useSessionStore } from "Common/Stores";
import { useState } from "react";
import { CorrelativeCreate } from "interfaces";
import { createCorrelative, updateCorrelative } from "services";
import {  useQueryClient } from "@tanstack/react-query";
import { NotificationType, showNotifications } from "helpers/toas_notification";
import { useCorrelativeList } from "./useCorrelativeList";

export const useFormCreateCorrelative = (onHideModal: VoidFunction) => {
  const { t } = useTranslation();
  const { session } = useSessionStore();

  const queryClient = useQueryClient();

  const { branchSelected } = useCorrelativeList();

  const { correlative, isEdith,} =
    useCorrelativeStore();

  const [companyId, setCompanyId] = useState(0);

  const initialValues = {
    correlative: correlative?.correlative || "",
    branch_id: correlative?.branch.id || branchSelected || "",
  };

  const validationSchema = Yup.object().shape({
    correlative: validateYupStringWithSpecialCharacters(t, true),
    branch_id: Yup.string().required(t("validationForms.required")),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      const payload: CorrelativeCreate = {
        correlative: values.correlative,
        branch_id: values.branch_id.toString(),
      };

      if (isEdith) {
        // Update Correlative

        handleEditCorrelative(payload);
      } else {
        // Create Correlative
        handleCreateCorrelative(payload);
      }
    },
  });

  const handleEditCorrelative = async (correlativeEdit: CorrelativeCreate) => {
    try {
      if (!correlative) return;

      const response = await updateCorrelative(
        correlativeEdit,
        correlative.id.toString()
      );

      if (response.code === "200") {
        showNotifications(
          NotificationType.SUCCESS,
          t("notificationsMessages.success")
        );
        queryClient.invalidateQueries({
          queryKey: ["correlatives"],
        });
        onHideModal();
      } else {
        showNotifications(
          NotificationType.ERROR,
          t("notificationsMessages.error") + response.message
        );
      }
    } catch (error) {
      showNotifications(
        NotificationType.ERROR,
        t("notificationsMessages.error") + error
      );
    }
  };

  const handleCreateCorrelative = async (
    correlativeCreate: CorrelativeCreate
  ) => {
    try {
      const response = await createCorrelative(correlativeCreate);

      if (response.code === "200") {
        showNotifications(
          NotificationType.SUCCESS,
           t("notificationsMessages.successAdd"),
        );
        queryClient.invalidateQueries({
          queryKey: ["correlatives"],
        });
        onHideModal();
        formik.resetForm();
      } else {
        showNotifications(
          NotificationType.ERROR,
          t("notificationsMessages.error") + response.message
        );
      }
    } catch (error) {
      showNotifications(
        NotificationType.ERROR,
        t("notificationsMessages.error") + error
      );
    }
  };

  return {
    t,
    isEdith,
    formik,
    session,
    companyId,
    setCompanyId,
  };
};
